(function () {
  'use strict';
  var panel = document.getElementById('happy-mug-consent');
  if (!panel) return;
  var api, attempts = 0;
  var buttons = panel.querySelectorAll('button');
  var status = panel.querySelector('[data-consent-status]');
  function open() { panel.hidden = false; }
  function ready() {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api) return;
    var consent = api.currentVisitorConsent();
    panel.querySelector('[data-consent-analytics]').checked = consent.analytics === 'yes';
    if (consent.analytics !== 'yes' && consent.analytics !== 'no') open();
    buttons.forEach(function(button) { button.disabled = false; });
    status.textContent = '';
  }
  function save(analytics) {
    if (!api) return;
    buttons.forEach(function(button) { button.disabled = true; });
    status.textContent = 'Auswahl wird gespeichert …';
    api.setTrackingConsent({ analytics: analytics }, function(result) {
      buttons.forEach(function(button) { button.disabled = false; });
      if (result && result.error) {
        status.textContent = 'Speichern fehlgeschlagen. Bitte erneut versuchen.';
        return;
      }
      panel.hidden = true;
      status.textContent = '';
      document.dispatchEvent(new CustomEvent('happyMugConsentChanged'));
    });
  }
  panel.querySelector('[data-consent-necessary]').addEventListener('click', function() { save(false); });
  panel.querySelector('[data-consent-save]').addEventListener('click', function() {
    save(panel.querySelector('[data-consent-analytics]').checked);
  });
  document.getElementById('happy-mug-consent-open').addEventListener('click', function() {
    if (api) panel.querySelector('[data-consent-analytics]').checked = api.currentVisitorConsent().analytics === 'yes';
    open();
  });
  function boot() {
    attempts++;
    if (window.Shopify && window.Shopify.customerPrivacy) { ready(); return; }
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function(error) {
        if (!error) ready();
        else { open(); status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Analyse bleibt deaktiviert.'; }
      });
    } else if (attempts < 20) window.setTimeout(boot, 250);
    else { open(); status.textContent = 'Analyse bleibt deaktiviert. Bitte lade die Seite neu.'; }
  }
  boot();
})();
